import React, { useState } from "react";
import { Link } from "react-router-dom";
import allProjects from "./projects";

export default function Portfolio(props) {
  const [visibleCount, setVisibleCount] = useState(6);

  const loadMore = () => {
    setVisibleCount((prevCount) =>
      Math.min(prevCount + 6, allProjects.length)
    );
  };

  const visibleProjects = allProjects.slice(0, visibleCount);

  const hasMore = visibleCount < allProjects.length;

  return (
    <section className="portfolio">
      <div className="container">
        <div className="row">
          <div className="aboutHeadings mb-5 text-center">
            <h2>{props.portfolioHeading}</h2>
            <h4 className="brandText">
              {props.portfolioSubHeading}
            </h4>
          </div>

          {visibleProjects.map((item) => (
            <div
              className="col-md-4 mb-4"
              key={item.id}
              data-aos="fade-down"
              data-aos-easing="ease-out-cubic"
              data-aos-duration="1000"
              data-aos-delay={item.delay}
            >
              <div className="portfolio-card">

                {/* Project Image */}
                <div className="portfolio-card-img">
                  <img
                    src={item.imgSrc}
                    alt={item.heading}
                    className="img-fluid"
                  />

                 {item.category === "featured" && (
  <span
    className="project-category-badge"
    title="Featured Project"
  >
    <i className="fas fa-crown"></i>
  </span>
)}
                </div>

                {/* Project Content */}
                <div
                  className={`portfolio-card-content bg-${
                    props.mode === "light" ? "" : "dark"
                  }`}
                >
                  <div className="portfolio-details">
                    <h5 className="text-white m-0">
                      {item.heading}
                    </h5>

                    <div className="readMoreBtn">
                      <h3 className="text-white">
                        {item.heading}
                      </h3>

                      <p className="text-white">
                        {item.detail}
                      </p>

                      <Link
                        to={`/portfolio-details/${item.id}`}
                        className="btn btn-primary2 small-btn mt-4"
                      >
                        {item.BtnText}
                      </Link>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          ))}
        </div>

        {/* Load More */}
        {hasMore && (
          <div className="text-center mt-4">
            <button
              className="btn btn-primary2"
              onClick={loadMore}
            >
              View More...
            </button>
          </div>
        )}
      </div>
    </section>
  );
}